import { ExternalResourceLink } from '@models/externalResourceLink';
import { LanguageEntityAdminApiService } from './languageEntityAdminApiService';

const adminExternalResourceLinkApiUrl = '/api/admin/external-resource-link';

export class ExternalResourceLinkAdminService extends LanguageEntityAdminApiService<ExternalResourceLink> {
    public constructor() {
        super(adminExternalResourceLinkApiUrl);
    }
}
